import { ApiHelper } from "../heplers/APIHelper";

const authApiHelper = new ApiHelper();

export const getNotifications = () => {
     return authApiHelper.post("user-notifications/getNotification", { });
};

export const markNotificationRead = (id: number) => {
     return authApiHelper.post(`user-notifications/mark-read?id=${id}`, {});
};

export const getUnreadCount = () => {
     return authApiHelper.post("user-notifications/countNotification", {});
};